module.exports = __webpack_public_path__ + "static/media/mobile_background.180289ef.png";